module.exports = __webpack_public_path__ + "static/5-5d9f42744715b1636acd1dfc11b6026e.jpg";